<template>
    <div class="desk-detail-wrapper">
        <div class="common-box">
            <div class="mt20 tar">
                <el-button size="mini" @click="goBackHandle">返回</el-button>
                <el-button size="mini" v-if="id" @click="orderDetailVisible = true">打印</el-button>
                <el-button size="mini" v-if="id" @click="orderDetailVisible = true">生成PDF</el-button>
            </div>
            <el-steps :active="active" align-center class="mt20">
                <el-step title="基本信息"></el-step>
                <el-step title="问题需求"></el-step>
                <el-step title="社工建议及行动"></el-step>
                <el-step title="帮扶对象是否愿意接收服务"></el-step>
                <el-step title="督导意见"></el-step>
            </el-steps>
            <stepOne v-if="active == 0" :data="data" :isDetail="isDetail" :orderId="orderId" @next="nextHandle" @refresh="refreshHandle"></stepOne>
            <stepTwo v-if="active == 1" :data="data" :isDetail="isDetail" :orderId="orderId" @next="nextHandle" @refresh="refreshHandle"></stepTwo>
            <stepThree v-if="active == 2" :data="data" :isDetail="isDetail" :orderId="orderId" @next="nextHandle" @refresh="refreshHandle"></stepThree>
            <stepFour v-if="active == 3" :data="data" :isDetail="isDetail" :orderId="orderId" @next="nextHandle" @refresh="refreshHandle"></stepFour>
            <stepFive v-if="active == 4" :data="data" :isDetail="isDetail" :orderId="orderId" @next="nextHandle" @refresh="refreshHandle"></stepFive>
        </div>
        <el-dialog title="档案详情" fullscreen append-to-body width="80%" :visible.sync="orderDetailVisible">
            <pdf :info="data" @close="orderDetailVisible = false"></pdf>
        </el-dialog>
    </div>
</template>
<script>
import stepOne from './components/step-one.vue'
import stepTwo from './components/step-two.vue'
import stepThree from './components/step-three.vue'
import stepFour from './components/step-four.vue'
import stepFive from './components/step-five.vue'
import pdf from '@/views/archives/components/jcda-pdf.vue'
import { getArchivesDetail } from '@/api/archives/index'
export default {
    name: 'order-detail',
    components: {
        stepOne,
        stepTwo,
        stepThree,
        stepFour,
        stepFive,
        pdf
    },
    created() {
        this.id = this.$route.query.id;
        if (this.id) {
            this.getDetail()
        }
    },
    data() {
        return {
            isDetail: this.$route.query.isDetail,
            orderId: this.$route.query.orderId,
            orderDetailVisible: false,
            active: 0,
            id: '',
            data: {}
        }
    },
    methods: {
        refreshHandle(id) {
            if (id) {
                this.id = id
                this.getDetail()
            }
        },
        nextHandle(num) {
            this.active = num
        },
        goBackHandle() {
            this.$router.$avueRouter.closeTag()
            this.$router.go(-1)
        },
        getDetail() {
            getArchivesDetail(this.id).then(res => {
                this.data = res.data.data
            })
        }
    }


}

</script>
